export default "__VITE_ASSET__UD6Kr$eW__"